import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import { apiCodeToOpenId } from './api';
import main, { AppLocalKey } from './main';
import { userInfoRequest } from './redux/userInfoReducer';
import { delay, parseLocationParams } from './utils/utils';
import FloatCustomer from './components/floatCustomer';
import { AppStore } from './types';

export default function MainPage() {
  const dispatch = useDispatch();
  const location = useLocation();
  // 设置悬浮客服是否显示
  const [showCustomer, setShowCustomer] = useState(false);
  // 客服配置
  const config = useSelector((state: AppStore) => state.systemConfig);

  useEffect(() => {
    handleResize();

    let { code } = parseLocationParams(location.search);
    let ua = window.navigator.userAgent.toLowerCase();

    let isWeixin = ua.includes('micromessenger');
    let openId = localStorage.getItem(main.appId);
    let uri = window.location.href;
    let redirect_uri = encodeURIComponent(uri);
    if (isWeixin && !code && !openId) {
      // 微信环境下啥都没有 跳转去授权
      document.location.replace(
        `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${main.appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
      );
    } else if (isWeixin && code && !openId) {
      getOpenId(code);
    }
    if (openId) {
      main.openId = openId;
    }
    if (main.isIos14) {
      main.enterUrl = window.location.href;
    }
    window.addEventListener('resize', handleResize);
  }, []); // eslint-disable-line

  useEffect(() => {
    if (!config?.results?.length) return;
    // 客服悬浮按钮 部分页面不显示
    const hidePage: string[] = [];
    const currPath = '/' + location.pathname.split('/')[1];
    let hide = hidePage.includes(currPath);
    if (!hide) {
      let customerUrl = config.results?.find((i) => i.configKey === AppLocalKey.customerH5);
      if (customerUrl) {
        setShowCustomer(true);
      }
    }
  }, [location, config]);

  function handleResize() {
    delay(300).then((v) => {
      document.body.setAttribute('style', '--window-height:' + window.innerHeight + 'px');
    });
  }

  /**
   * 获取openId
   * @param code
   */
  async function getOpenId(code: string) {
    try {
      let res = await apiCodeToOpenId(code);
      let data = res.data;
      if (data.code === 200) {
        main.openId = data.data;
        localStorage.setItem(main.appId, main.openId ?? '');
      }
    } catch (e) {}
  }

  useEffect(() => {
    let token = localStorage.getItem(AppLocalKey.loginToken);
    if (token) {
      main.loginToken = token;
      dispatch(userInfoRequest());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Outlet />
      {showCustomer && <FloatCustomer />}
    </div>
  );
}
